'use client';

import React from 'react';
import Introduce from './Introduce';
import Product from './Product';
import Footer from '../components/Footer';
import Bottom from './Bottom';
import Header from '../components/Header';
import { ProductContextProvider } from './productContext';

export default function Products() {
  return (
    <div className="flex flex-col justify-center w-full bg-base-white">
      <Header />
      <div className="flex flex-col items-center justify-center z-10 mt-[68px] w-[1280px] mx-auto">
        <Introduce />
        <ProductContextProvider>
          <Product />
        </ProductContextProvider>
      </div>
      <Bottom />
      <Footer />
    </div>
  );
}
